import 'fullpage.js/vendors/scrolloverflow'
import fullpage from 'fullpage.js';

export default {
  init() {
    new fullpage('#fullpage', {
      licenseKey: 'A9AAB014-DA6C42AC-9336C7B6-1DFF5C4A',

      //Navigation
      menu: 'nav',
      lockAnchors: false,
      navigation: true,
      navigationPosition: 'left',
      showActiveTooltip: true,
      slidesNavigation: true,
      slidesNavPosition: 'top',
      tooltipPosition: 'right',

      //Accessibility
      keyboardScrolling: true,
      animateAnchor: true,
      recordHistory: true,

      //Design
      controlArrows: true,
      verticalCentered: true,
      paddingTop: '5rem',
      paddingBottom: '5rem',
      fixedElements: 'nav, .background-wrapper, #small_nav',
      responsiveWidth: 1024,
      responsiveHeight: 0,
      responsiveSlides: true,
      parallax: true,
      parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},

      //Custom selectors
      sectionSelector: '.section',
      slideSelector: '.slide',
      lazyLoading: false,

      //events
      onLeave: function(nextIndex){
      var num_slides = $('.fullpage-wrapper .fp-section').length;

      $('body').removeClass('fp-last-slide');
        if ( num_slides == nextIndex ) {
          $('body').addClass('fp-last-slide');
        }
      },
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/historie.js